import { UserWithMeta } from 'src/common-services/types/user-types'
import { BaseClient } from 'src/common-services/clients/base-client'
import { WebSignUpRequest } from 'src/common-services'

export class SignUpClient extends BaseClient {
  signUp(request: WebSignUpRequest): Promise<UserWithMeta> {
    return this.call<UserWithMeta>('/signup', 'POST', { data: request })
  }
}
